<template>
  <div :class="['wrap_list', isTopType ? 'type_top' : 'type_bottom']">
    <strong
      v-if="isTopType"
      class="tit_list"
      >{{ props.listData.name }} <em>{{ props.listData.contentLength }}</em></strong
    >
    <ListCategory
      v-if="props.listData.name === '자료실'"
      :title="props.listData.name"
      :listData="props.listData.list"
      :isMoreList="false"
      :listType="'search'"
      class="list_default"
    />
    <ul
      v-else
      :class="['list_default', { type_bottom: isBottomType }]"
    >
      <li
        v-for="(card, indexCard) in props.listData.list"
        :key="`${indexCard}_card`"
      >
        <CardSearch
          :cardData="card"
          :type="isTopType ? 'top' : 'bottom'"
          :contentType="props.contentType"
        />
      </li>
    </ul>
  </div>
</template>
<script setup>
const props = defineProps({
  listData: {
    type: Object,
    default() {
      return {};
    },
  },
  type: {
    type: String,
    default: '',
  },
  contentType: {
    type: String,
    default: '',
  },
});

const isTopType = computed(() => {
  return props.type === 'top' ? true : false;
});

const isBottomType = computed(() => {
  return props.type === 'bottom' ? true : false;
});
</script>

<style lang="scss" scoped>
.wrap_list.type_top {
  & + .type_top {
    margin-top: 40px;
  }
  .tit_list {
    display: block;
    font-size: 24px;
    line-height: 1.75;
    letter-spacing: -0.5px;
    font-weight: 700;
    margin-bottom: 24px;
    em {
      color: #1b72ff;
      font-weight: 700;
    }
  }
}
.wrap_list + .wrap_list.type_bottom {
  margin-top: 60px;
  padding-top: 60px;
  border-top: 1px solid #f0f0f0;
}
.list_default {
  li {
    & + li {
      margin-top: 40px;
    }
  }
}
@media screen and (max-width: 811px) {
  .wrap_list.type_top {
    & + .type_top {
      margin-top: 60px;
    }
    .tit_list {
      font-size: 18px;
      line-height: 1.5;
      margin-bottom: 16px;
    }
  }
  .wrap_list + .wrap_list.type_bottom {
    margin-top: 64px;
    padding-top: 64px;
  }
  .list_default {
    &.type_bottom {
      li {
        & + li {
          margin-top: 60px;
        }
      }
    }
  }
}
</style>
